import { render } from "./401.vue?vue&type=template&id=64d81746&scoped=true"
import script from "./401.vue?vue&type=script&lang=ts"
export * from "./401.vue?vue&type=script&lang=ts"

import "./401.vue?vue&type=style&index=0&id=64d81746&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-64d81746"

export default script